var map = {
	"./american-football.svg": 7583,
	"./anime.svg": 6669,
	"./art-and-design.svg": 4028,
	"./athletics.svg": 8611,
	"./baseball-player.svg": 2001,
	"./baseball.svg": 5407,
	"./basketball.svg": 1824,
	"./beauty.svg": 9319,
	"./boxing.svg": 4855,
	"./cars.svg": 8716,
	"./comic-books.svg": 3695,
	"./concert-or-theatre-tickets.svg": 1923,
	"./consumer-electronics,-appliances-&-accessories.svg": 6324,
	"./coupons-and-saving-money.svg": 9908,
	"./cricket.svg": 3293,
	"./crypto--nft.svg": 2528,
	"./cycling.svg": 376,
	"./electric-vehicles.svg": 2085,
	"./electronics.svg": 5722,
	"./entertainment-&-resorts.svg": 4544,
	"./entertainment.svg": 3720,
	"./equestrian-sports.svg": 2665,
	"./extreme-sports.svg": 1095,
	"./fashion-affordable.svg": 4842,
	"./fashion-luxury.svg": 1348,
	"./fashion-premium.svg": 1207,
	"./fashion.svg": 3350,
	"./finance.svg": 1334,
	"./financial-technology.svg": 9471,
	"./fitness.svg": 7992,
	"./football.svg": 1834,
	"./gambling-and-casinos.svg": 4843,
	"./gaming.svg": 5533,
	"./golf.svg": 4755,
	"./gymnastics.svg": 4449,
	"./haircare.svg": 3190,
	"./health-and-wellbeing.svg": 1953,
	"./insurance.svg": 2141,
	"./international-air-travel.svg": 8378,
	"./learning-and-education.svg": 6770,
	"./male-grooming.svg": 912,
	"./martial-arts.svg": 2227,
	"./motor-sports.svg": 3261,
	"./music.svg": 7623,
	"./netball.svg": 3464,
	"./online-audio-subscription-services.svg": 2867,
	"./online-gaming.svg": 7373,
	"./online-shopper.svg": 2805,
	"./online-video-subscription-services.svg": 3529,
	"./personal-finance.svg": 8014,
	"./pilates-yoga-and-meditation.svg": 7808,
	"./professional-sports.svg": 3860,
	"./racket-sports.svg": 5512,
	"./rugby-league.svg": 221,
	"./rugby-union.svg": 3323,
	"./running,-marathons & triathlons.svg": 8319,
	"./running,-marathons-&-triathlons.svg": 8466,
	"./running-marathons-and-triathlons.svg": 2450,
	"./running.svg": 3735,
	"./shopping.svg": 9906,
	"./sleep-optimisation.svg": 880,
	"./sporting-goods-online.svg": 5265,
	"./sports-games.svg": 2260,
	"./sports-nutrition.svg": 9369,
	"./sports.svg": 9218,
	"./sportswear-and-lifestyle.svg": 710,
	"./streaming-services.svg": 8917,
	"./sustainability.svg": 670,
	"./technology.svg": 3413,
	"./tennis.svg": 1590,
	"./trading.svg": 4709,
	"./travel-and-leisure.svg": 5817,
	"./tv-entertainment.svg": 8789,
	"./watches.svg": 7250,
	"./watching-movies.svg": 7021,
	"./water-sports.svg": 3016,
	"./web3.svg": 8904,
	"./winter-sports.svg": 5907,
	"./wrestling.svg": 6947
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 860;